import React from "react";
import Recommended from "./Recommended";
import NewlyAddedStores from "./NewlyAdded";
import MostTrendingStore from "./MostTrending";
import Slider from "./Slider";
import Banner from "./Banner2";
import {
  getEndUserAction,
} from "../../../../Store/Coupons/actions";
import { useDispatch, useSelector } from "react-redux";

function Index() {


  const dispatch = useDispatch();
  const { getEndUser } = useSelector((state) => state.Coupon);


  React.useEffect(() => {
    dispatch(getEndUserAction());
  }, [dispatch]);


  return (
    <div>
      <Slider />
      <MostTrendingStore />
      <Banner getEndUser={getEndUser} />
      <Recommended />
      <NewlyAddedStores />
    </div>
  );
}

export default Index;
